
export default {
  outlaycategories: []
}
